/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { StandardPagination, SubPage, ToolTip, CheckBox, Title, DragDropContext, Droppable } from '@insticator/insticator-ui'; // iui-material
import ContentCard from 'material/embeds/contentcard/contentcard_container';
import CustomToggle from 'pages/dashboard/embeds/management/organize/toggle/toggle';
import MoveLiveContent from 'pages/dashboard/embeds/management/organize/movelivecontent/movelivecontent';
import ControlBar from 'material/embeds/controlbar/controlbar';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/organize/organize_styles';



/* ========== ~~~~~~~~~~ EMBED ORGANIZE ~~~~~~~~~~ ========== */
class OrganizeContentPage extends Component {
    constructor(props) {
        super(props);
        const { liveContent, notLiveContent } = this.getItems(this.props.contents);
        this.itemsPerPage = 10;
        this.contentNotLive = notLiveContent;
        this.typedText = '';
        this.content = [];
        this.state = {
            searchTerm: '',
            livePosition: 0,
            notLivePosition: 0,
            movingCard: null,
            highlighted: null,
            contentLive: liveContent,
            sortedContents: this.contentNotLive
        };
    }
    componentWillMount() {
        document.addEventListener('mousedown', this.handleOutsideClick, false);
    }
    componentWillUnmount() {
        if (this.state.contentLive.length === 0) {
            // this.props.addContent('quiz');
            this.props.updateNoLiveContent(true);
        } else {
            const lastContent = this.state.contentLive[this.state.contentLive.length - 1]['id'];
            this.props.selectContent(lastContent);
            this.props.updateNoLiveContent(false);
        }
        document.removeEventListener('mousedown', this.handleOutsideClick, false);
    }
    componentDidUpdate(prevProps) {
        if (JSON.stringify(this.props.contents) !== JSON.stringify(prevProps.contents)) {
            const {liveContent, notLiveContent} = this.getItems(this.props.contents);
            this.contentNotLive = notLiveContent;
            this.setState({ contentLive: liveContent, livePosition: this.handlePositionAfterStatusChange(liveContent.slice(this.state.livePosition, this.state.livePosition+10).length === 0 && this.state.livePosition >= 10) });
            this.applyFilters();
            this.handlePageAfterCardMove(this.state.movingCard);
        }
    }

    applyFilters = () => {
        // store existing filter types
        const types = { content: this.content.length > 0, search: this.typedText.length > 0 };
        // filter items based on type that exists and value
        let filteredItems = this.contentNotLive.filter(content => {
            if (types.content) {
                return this.content.some(filter => filter === content.type);
            } else {
                return this.contentNotLive;
            }
        });
        // now search what was filtered
        if (types.search) filteredItems = filteredItems.filter(question => question.title.toLowerCase().includes(this.typedText.toLowerCase()));
        // render filter items
        this.setState({ sortedContents: filteredItems, notLivePosition: 0 });
    };
    handleSearch = (typedText) => {
        this.typedText = typedText;
        this.applyFilters();
    };

    // list management for drag and drop
    id2List = { droppable: 'contentLive', droppable2: 'sortedContents' }; // Handle multiple lists. Matches the IDs of the droppable container to the names of the source arrays stored in the state
    getList = id => this.state[this.id2List[id]];
    getDetail = (content) => ((content.contentType === 'story') ? content.story : content.questionBased);
    getItems = (contents) => {

        let liveContent = [];
        let notLiveContent = [];
        for (let contentId of Object.keys(contents)) {
            const contentDetail = this.getDetail(contents[contentId]);
            if (this.props.contents[contentId].contentLive === true) {
                liveContent.push({
                    id: `${contentId}`,
                    number: contents[contentId]['queuePosition'] + 1,
                    queuePosition: contents[contentId]['queuePosition'],
                    type: contents[contentId]['contentType'],
                    title: contentDetail['title'],
                    options: contentDetail['options'],
                    content: <ContentCard key={`${this.props.contents[contentId].contentType}${contentId}`}
                                          contentId={contentId}
                                          organize={true}
                                          isClickable={false}
                                          processClick={null}
                                          type={this.props.contents[contentId].contentType}
                                          number={contents[contentId]['queuePosition'] + 1}
                                          size={`medium`} />
                })
            } else {
                notLiveContent.push({
                    id: `${contentId}`,
                    number: contents[contentId]['queuePosition'] + 1,
                    queuePosition: contents[contentId]['queuePosition'],
                    type: contents[contentId]['contentType'],
                    title: contentDetail['title'],
                    options: contentDetail['options'],
                    content: <ContentCard key={`${this.props.contents[contentId].contentType}${contentId}`}
                                          contentId={contentId}
                                          organize={true}
                                          isClickable={false}
                                          processClick={null}
                                          type={this.props.contents[contentId].contentType}
                                          number={contents[contentId]['queuePosition'] + 1}
                                          size={`medium`} />
                })
            }
        }
        liveContent.sort(function (a, b) { return (a.queuePosition > b.queuePosition) ? 1 : ((b.queuePosition > a.queuePosition) ? -1 : 0); });
        return {liveContent, notLiveContent};
    };

    //handle reorder via fields

    handleCardMove = (startIndex, endIndex) => {
        this.setState({movingCard: (endIndex+1)});
        const contentLive = this.reorder(
            this.state.contentLive,
            startIndex,
            endIndex
        );
        this.props.reorderContents(contentLive, []);
    };

    handlePositionAfterStatusChange = (zeroOnPage) => zeroOnPage ? this.state.livePosition - 10 : this.state.livePosition;

    handlePageAfterCardMove = (cardNumber) => {
        if (cardNumber === null) return null;
        let position = (cardNumber % 10 > 0) ? Math.trunc(cardNumber / 10) : Math.trunc(cardNumber / 10) - 1;
        this.setState({livePosition: position * 10, movingCard: null, highlighted: (cardNumber - 1)});
        this.endCardHighlight();
    };

    handleMovedCardHighlight = (startCardIndex) => this.setState({highlighted: startCardIndex});

    endCardHighlight = () => setTimeout(()=>this.setState({highlighted: null}), 3000);

    // a little function to help us with reordering the result
    reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };
    // Moves an item from one list to another list.
    move = (source, destination, droppableSource, droppableDestination) => {
        const sourceClone = Array.from(source);
        const destClone = Array.from(destination);
        const [removed] = sourceClone.splice(droppableSource.index, 1);

        destClone.splice(droppableDestination.index, 0, removed);

        const result = {};
        result[droppableSource.droppableId] = sourceClone;
        result[droppableDestination.droppableId] = destClone;
        return result;
    };
    onDragEnd = result => {
        const { source, destination } = result;
        if (!destination) { return; } // dropped outside the list
        if (source.droppableId === destination.droppableId) {
            // let state = { contentLive };
            if (source.droppableId === 'droppable2') {
                return;
            } else {
                destination.index += this.state.livePosition;
                const contentLive = this.reorder(
                    this.state.contentLive,
                    source.index,
                    destination.index
                );
                this.props.reorderContents(contentLive, []);
            }

        } else {
            destination.index += this.state.livePosition;
            const result = this.move(
                this.getList(source.droppableId),
                this.getList(destination.droppableId),
                source,
                destination
            );
            this.props.reorderContents(result.droppable, result.droppable2);
        }
    };
    notLiveToLive = (index) => {
        let live = this.state.contentLive;
        let notLive = this.state.sortedContents;
        let movedItem = notLive.splice(index, 1);
        // this.setState({searchTerm: '', livePosition: (Math.floor(live.length/this.itemsPerPage) * 10) , notLivePosition: ((notLive.splice(this.state.notLivePosition, 10).length === 0) ? this.state.notLivePosition - 10 : this.state.notLivePosition)});
        this.props.reorderContents([ ...live, ...movedItem], notLive);
    };
    liveToNotLive = index => {
        let live = this.state.contentLive;
        let notLive = this.state.sortedContents;
        let movedItem = live.splice(index, 1);
        // if(live.slice(this.state.livePosition, this.state.livePosition+10).length === 0 && this.state.livePosition >= 10) this.setState({livePosition: this.state.livePosition - 10});
        this.props.reorderContents(live, [ ...notLive, ...movedItem]);
    };
    showPlacement() {
        return this.props.location === 'in-content' ? 'incontent' : 'rail';
    }
    setContentOrder = (value, checked) => {
        this.props.setEmbedProperty('contentOrder', checked ? 'random' : 'ordered');
    };
    handleOutsideClick = (e) => {
        // ignore clicks on the component itself
        if (this.node.contains(e.target)) { return; }
        this.props.displayModal(false);
    };
    handleLivePagination = (direction)=>{
        switch (direction) {
            case 'next':
                this.setState({livePosition: this.state.livePosition + 10});
                break;
            case 'prev':
                this.setState({livePosition: this.state.livePosition === 0 ? 0 : this.state.livePosition - 10});
                break;
            case 'first':
                this.setState({livePosition: 0});
                break;
            case 'last':
                let itemsLength = this.state.contentLive.length;
                let position = (itemsLength % 10 > 0) ? Math.trunc(itemsLength / 10) : Math.trunc(itemsLength / 10) - 1;
                this.setState({livePosition: position * 10});
                break;
            default:
                break;
        }
    };

    handleNotLivePagination = (direction)=>{
        switch (direction) {
            case 'next':
                this.setState({notLivePosition: this.state.notLivePosition + 10});
                break;
            case 'prev':
                this.setState({notLivePosition: this.state.notLivePosition === 0 ? 0 : this.state.notLivePosition - 10});
                break;
            case 'first':
                this.setState({notLivePosition: 0});
                break;
            case 'last':
                let itemsLength = this.state.sortedContents.length;
                // let position = (itemsLength % 10 > 0) ? Math.trunc(itemsLength / 10) : Math.trunc(itemsLength / 10) - 1;
                let position = (itemsLength % 10 > 0) ? Math.trunc(itemsLength / 10) : Math.trunc(itemsLength / 10) - 1;
                this.setState({notLivePosition: position * 10});
                break;
            default:
                break;
        }
    };

    renderPagination = (live)=>{
        if(live){
            return this.state.contentLive.length > this.itemsPerPage && <div className={`pagination`}> <StandardPagination
                handlePrevious={()=>this.handleLivePagination('prev')}
                handleNext={()=>this.handleLivePagination('next')}
                handleFirst={()=>this.handleLivePagination('first')}
                handleLast={()=>this.handleLivePagination('last')}
                firstLastButtons={true}
                itemsPerPage={this.itemsPerPage}
                totalItems={this.state.contentLive.length}
                currentIndex={this.state.livePosition + 10}
            /></div>
        } else{
            return this.state.sortedContents.length > this.itemsPerPage && <div className={`pagination`}> <StandardPagination
                handlePrevious={()=>this.handleNotLivePagination('prev')}
                handleNext={()=>this.handleNotLivePagination('next')}
                handleFirst={()=>this.handleNotLivePagination('first')}
                handleLast={()=>this.handleNotLivePagination('last')}
                firstLastButtons={true}
                itemsPerPage={this.itemsPerPage}
                totalItems={this.state.sortedContents.length}
                currentIndex={this.state.notLivePosition + 10}
            /></div>
        }
    };
    handleSelectType = (types) => {
        this.content = types.map(type => type.toLowerCase());
        this.applyFilters();
    };

    renderCards = (live, indexStart, indexEnd) => {
        const content = live ? this.state.contentLive : this.state.sortedContents;
        let cards = [];
        content.slice(indexStart, indexEnd).forEach((item, index) => cards.push({
            id: item.id,
            position:index+=indexStart,
            element: <div className={`highlighted-${(index === this.state.highlighted) && live}`}>
                <CustomToggle assignment={true} live={live} toggleMethods={{
                    notLiveToLive: this.notLiveToLive,
                    liveToNotLive: this.liveToNotLive
                }} index={index} />
                {item.content}
            </div>
        }));
        return cards;
    };

    render() {
        return (
            <DragDropContext onDragEnd={this.onDragEnd}>
                <SubPage name={`organize`} klass={`${this.props.classes.organize} ${this.showPlacement()}`}>
                    <div className={`inner`} ref={node => { this.node = node; }}>
                        <Title klass={`pagetitle`}>
                            <h2>Organize your cards</h2>
                        </Title>
                        <div className={'group toplevel'}>
                            <div className={`headline live`}>
                                <div className={`group`}>
                                    <h3>Your Embed ({this.props.numberOfActiveContents} live cards)</h3>
                                </div>
                                <div className={`group`}>
                                    <ToolTip position={`top`} action={`mouseenter`} content={`The order in which users see your content will be randomized.`}>
                                        <span className={`randomize`} >
                                            <CheckBox handleClick={this.setContentOrder} color={'system'} on={this.props.contentOrder === 'random'} /> Randomize Content
                                        </span>
                                    </ToolTip>
                                </div>
                            </div>
                            <div className={`contentpieces live`}>
                                <Droppable
                                    klass={`cardcontainer`}
                                    droppableId= {"droppable"}
                                    direction={"horizontal"}
                                    elements={this.renderCards(true, this.state.livePosition, this.state.livePosition+this.itemsPerPage)}
                                />
                                {(this.props.contentOrder !== 'random' && this.state.contentLive.length > 2)
                                && <MoveLiveContent handleMove={this.handleCardMove} numberOfLiveContents={this.props.numberOfActiveContents} setStartCard={this.handleMovedCardHighlight}/>}
                                {this.renderPagination(true)}
                            </div>
                        </div>
                        <div className={'group toplevel'}>
                            <div className={`headline notlive`}>
                                <div className={`group headline-group`}>
                                    <h3>Cards Not Live ({this.props.numberOfInactiveContents})</h3>
                                </div>
                                <div className={`group`}>
                                    <ControlBar
                                        searchDefaultValue={this.typedText}
                                        searchPlaceholder={`Search Card`}
                                        searchOnChange={this.handleSearch}
                                        handleSelectType={this.handleSelectType}
                                        organize={true}
                                    />
                                </div>
                            </div>
                            <div className={`contentpieces notlive`}>
                                <Droppable
                                    klass={`cardcontainer`}
                                    droppableId= {"droppable2"}
                                    direction={"horizontal"}
                                    elements={this.renderCards(false, this.state.notLivePosition, this.state.notLivePosition+this.itemsPerPage)}
                                />
                                {this.renderPagination(false)}
                            </div>
                        </div>
                    </div>
                </SubPage>
            </DragDropContext>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(OrganizeContentPage);
